import React, { FC, Fragment } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ValidatedSwitch, ValidatedTextField, ValidatedTextFieldNext } from 'components';

const MenuItem: FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Grid container>
        <Grid item xs={3}>
          <Typography variant="subtitle2">{t('components:menuItem')}</Typography>
        </Grid>
        <Grid item xs>
          <Grid container>
            <Grid item xs={11}>
              <Grid item xs={9}>
                <ValidatedTextFieldNext
                  name="menu_item.title"
                  fullWidth
                  label={t('common:title')}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={9}>
                <Box marginTop={4}>
                  <ValidatedTextField
                    TextFieldProps={{ margin: 'none' }}
                    i18nKey="common:link"
                    name="menu_item.link"
                    persistLabel
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid item xs>
              <ValidatedSwitch name="menu_item_enabled" color="primary" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default MenuItem;
